
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.005 21.987a9.768 9.768 0 01-7.271-3.244.744.744 0 01-.19-.542.75.75 0 011.308-.459 8.264 8.264 0 0011.65.647 8.277 8.277 0 002.666-5.005l-.888.886a.744.744 0 01-1.06 0 .752.752 0 010-1.061l2.25-2.25a.478.478 0 01.058-.048.719.719 0 01.248-.133.774.774 0 01.287-.032.798.798 0 01.26.07.784.784 0 01.15.095c.02.014.039.029.054.044l2.253 2.253a.744.744 0 010 1.06.749.749 0 01-1.06 0l-1.025-1.025a9.776 9.776 0 01-3.194 6.261 9.716 9.716 0 01-6.496 2.483zM3 13.743a.751.751 0 01-.562-.255L.22 11.271A.745.745 0 010 10.74c0-.2.078-.389.22-.53a.744.744 0 011.06 0l1.025 1.025a9.78 9.78 0 013.193-6.26 9.726 9.726 0 017.043-2.47 9.687 9.687 0 016.726 3.234.75.75 0 01-1.118 1A8.263 8.263 0 006.5 6.092a8.274 8.274 0 00-2.666 5.004l.886-.886a.744.744 0 011.06 0 .744.744 0 010 1.06l-2.235 2.235a.732.732 0 01-.545.238z"}}),_c('path',{attrs:{"d":"M12 13.74a.75.75 0 01-.75-.75v-6a.75.75 0 011.5 0v6a.75.75 0 01-.75.75zM12 17.493c-.62 0-1.125-.505-1.125-1.125 0-.573.427-1.048.996-1.114a.76.76 0 01.269-.002l.033.008c.544.085.951.556.951 1.108A1.125 1.125 0 0112 17.493z"}})])
          )
        }
      }
    